import script from "./AskDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./AskDialog.vue?vue&type=script&setup=true&lang=ts"

import "./AskDialog.vue?vue&type=style&index=0&id=4ecdd1e5&lang=scss"

const __exports__ = script;

export default __exports__